export class ForwardRef {
    constructor(forwardRefFn) {
        this.forwardRefFn = forwardRefFn;
    }
    getRef() {
        return this.forwardRefFn();
    }
}
/**
 * 引用后声明的类的工具函数
 * @param fn
 */
export function forwardRef(fn) {
    return new ForwardRef(fn);
}
